<template>
  <div class="cover-row apple-artist-album-grid">
    <article v-for="album in items" :key="album.id" class="item apple-artist-album-card">
      <Cover :ref="'album-' + album.id" :id="album.id" :label="album.name" :image-url="album.picUrl || album.coverImgUrl || album.coverUrl || ''" :tracks="album.tracks || null" :source-filter="sourceFilter" type="album" />
      <div class="apple-artist-album-heading"><router-link :to="route(album)" :title="album.name">{{ album.name }}</router-link><AppleDetailMore :label="'专辑更多操作 ' + album.name" :items="actions" @choose="choose(album,$event)" /></div>
      <div class="apple-artist-album-facts"><span v-if="year(album)">{{ year(album) }}</span><span v-if="count(album) !== null">{{ count(album) }} 首歌曲</span></div>
    </article>
  </div>
</template>
<script>
import Cover from '../components/Cover.vue';
import AppleDetailMore from './AppleDetailMore.vue';
import { releaseYear } from './search-entity-metadata';
export default {
  name:'AppleArtistAlbumGrid',components:{Cover,AppleDetailMore},
  props:{items:{type:Array,required:true},sourceFilter:{type:String,default:'all'}},
  data(){return {actions:[{id:'open',label:'打开专辑'},{id:'play',label:'播放专辑'}]};},
  methods:{
    route(album){return {name:'album',params:{id:String(album.id)},query:this.sourceFilter!=='all'&&String(album.id).startsWith('local:')?{source:this.sourceFilter}:{}};},
    year:releaseYear,
    count(album){const value=album.size??album.songCount??album.trackCount;if(value===undefined||value===null||value==='')return null;const number=Number(value);return Number.isFinite(number)&&number>=0?number:null;},
    choose(album,action){if(action==='open')this.$router.push(this.route(album)).catch(()=>{});else if(action==='play')[this.$refs['album-'+album.id]].flat().find(Boolean)?.play();},
  },
};
</script>
<style lang="scss">
#app.apple-shell .apple-artist-album-grid {
  display:grid;min-width:0;grid-template-columns:repeat(4,minmax(0,1fr));
  .apple-artist-album-card { min-width:0; }
  .cover { display:block;aspect-ratio:1; }
  .cover-container { width:100%;height:100%;aspect-ratio:1; }
  .cover img { display:block;width:100%;height:100%;object-fit:cover; }
  .apple-artist-album-heading { display:flex;align-items:center;gap:8px;margin-top:10px;min-width:0; }
  .apple-artist-album-heading > a { flex:1;min-width:0;overflow:hidden;color:var(--color-text);font-size:18px;font-weight:600;line-height:1.35;text-overflow:ellipsis;white-space:nowrap;text-decoration:none; }
  .apple-artist-album-heading > a:focus-visible { outline:0;box-shadow:inset 0 0 0 1px var(--apple-accent); }
  .apple-detail-more-trigger { width:26px;height:28px;background:transparent; }
  .apple-detail-more-trigger svg { width:18px;height:18px; }
  .apple-detail-more-menu { right:0;left:auto; }
  .apple-artist-album-facts { display:grid;gap:3px;margin-top:4px;color:var(--apple-muted);font-size:15px;line-height:1.4; }
}
</style>
